<template>
  <el-dialog
    top="40px"
    width="800px"
    :title="`${isCreate ? 'Thêm' : 'Sửa'} trường dữ liệu`"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    @close="$emit('close')"
  >
    <el-form
ref="form"
:model="form"
:rules="rules"
size="small">
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col :span="4">
          <el-form-item
prop="order"
label="STT">
            <el-input-number
v-model="form.order"
:min="0"
class="w-100" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
prop="type"
label="Loại trường">
            <el-select
              v-model="form.type"
              placeholder="Chọn loại"
              class="w-100"
            >
              <el-option
                v-for="op in typeOptions"
                :key="op.key"
                :label="op.label"
                :value="op.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.type === fieldType.GENERATOR"
          :span="12"
        >
          <el-form-item
prop="config"
label="Format">
            <el-input
              v-model="form.config"
              placeholder="EX: HV_{CODE}"
              :disabled="!!item"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
prop="key"
label="Mã trường">
            <el-input
              v-model="form.key"
              placeholder="EX: key_example"
              :disabled="!!item"
              @input="form.key = form.key.toLowerCase()"
            />
          </el-form-item>
        </el-col>
        <el-col
v-if="showCategoryOptions"
:span="12">
          <el-form-item
prop="options.type"
label="Loại Options">
            <el-select
              v-model="form.options.type"
              placeholder="Chọn loại"
              class="w-100"
              filterable
              :disabled="disableOptions"
              @change="() => (form.options.value = [])"
            >
              <el-option
                label="Danh mục cố định"
                :value="null"
              />
              <el-option
                v-for="category in allCategories"
                :key="category.id"
                :label="category.extra.name"
                :value="category.extra.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
v-if="showCategoryOptions"
:span="12">
          <el-form-item
prop="options.value"
label="Options">
            <el-select
              v-model="form.options.value"
              placeholder="Nhập tên để thêm option"
              class="w-100"
              :disabled="!!form.options.type"
              multiple
              filterable
              allow-create
              default-first-option
            >
              <el-option
                v-for="option in form.options.value"
                :key="option"
                :label="option"
                :value="option"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
v-if="showConnectionOptions"
:span="12">
          <el-form-item
prop="connection_options.type"
label="Loại Options">
            <el-select
              v-model="form.connection_options.type"
              placeholder="Chọn loại liên kết"
              class="w-100"
              filterable
            >
              <el-option
                v-for="category in allObjects"
                :key="category.id"
                :label="category.extra.name"
                :value="category.extra.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
prop="name"
label="Tên trường">
            <el-input
v-model="form.name"
placeholder="Nhập tên" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
prop="label"
label="Tên hiển thị">
            <el-input
v-model="form.label"
placeholder="Nhập tên hiển thị" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
prop="description"
label="Mô tả">
            <el-input
v-model="form.description"
placeholder="Nhập mô tả" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
prop="form_width"
label="Kích thước">
            <el-select
              v-model="form.form_width"
              placeholder="Chọn chiều dài"
              class="w-100"
            >
              <el-option
                v-for="op in formWidths"
                :key="op.value"
                :label="op.label"
                :value="op.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        v-if="showFieldConfig"
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
v-if="showDataType"
:span="8">
          <el-form-item
prop="form.pattern"
label="Loại dữ liệu">
            <el-select
              v-model="form.form.pattern"
              placeholder="Chọn loại"
              class="w-100"
            >
              <el-option
                v-for="op in dataTypes"
                :key="op.key"
                :label="op.label"
                :value="op.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
v-if="showDateFormat"
:span="8">
          <el-form-item
prop="format"
label="Format hiển thị">
            <el-select
              v-model="form.format"
              placeholder="Chọn format"
              class="w-100"
            >
              <el-option
                v-for="op in dateFormats"
                :key="op"
                :label="op"
                :value="op"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
v-if="showMinMax"
:span="8">
          <el-form-item
prop="form.min"
label="Giá trị nhỏ nhất">
            <el-input-number
v-model="form.form.min"
class="w-100" />
          </el-form-item>
        </el-col>
        <el-col
v-if="showMinMax"
:span="8">
          <el-form-item
prop="form.max"
label="Giá trị lớn nhất">
            <el-input-number
v-model="form.form.max"
class="w-100" />
          </el-form-item>
        </el-col>
        <el-col
v-if="showColumn"
:span="8">
          <el-form-item
prop="column.width"
label="Kích thước cột">
            <el-input-number
              v-model="form.column.width"
              class="w-100"
              :disabled="false"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
slot="footer"
class="dialog-footer">
      <el-button
:disabled="callingAPI"
size="medium"
@click="$emit('close')"
        >Đóng</el-button
      >
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleSave"
        >Lưu</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import PATTERNS from "@/config/patterns.js";
import CONSTANTS from "@/config/constants";
import { notification } from "@/utils/common";

const fieldInfoDefault = {
  type: "",
  config: "",
  key: "",
  name: "",
  label: "",
  form_width: 24,
  description: "",
  order: 0,
  format: null,
  show: {
    filter: false,
    fast_filter: false,
    column: false,
    create_form: false,
    import_export: false,
  },
  form: {
    required: false,
    pattern: null,
    min: null,
    max: null,
  },
  column: {
    width: null,
    short: false,
  },
  options: {
    type: null,
    value: [],
  },
  connection_options: {
    type: null,
  },
};
export default {
  name: "FieldFormPopup",
  props: {
    item: Object,
    visible: Boolean,
    object: Object,
    allConfigs: Array,
  },
  data() {
    return {
      form: {},
      callingAPI: false,
      formWidths: CONSTANTS.FORM_WIDTHS,
      dataTypes: CONSTANTS.DATA_TYPES,
      fieldType: CONSTANTS.FIELD_TYPE,
      dateFormats: CONSTANTS.DATE_FORMATS,
      optionsValue: [],
    };
  },
  computed: {
    isCreate() {
      return !this.item || !this.item.key;
    },
    moduleField() {
      return (this.object?.extra?.fields || [])
        .find((c) => c.type === this.fieldType.MODULE)
    },
    typeOptions() {
      if (this.object.type === "categories") {
        return CONSTANTS.FIELD_TYPES.slice(0, 5);
      }
      if (this.moduleField) {
        return CONSTANTS.FIELD_TYPES.filter((t) => t.key !== this.fieldType.MODULE);
      }
      return CONSTANTS.FIELD_TYPES;
    },
    groups() {
      return this.object?.extra?.groups || [];
    },
    allFieldKeys() {
      return (this.object?.extra?.fields || [])
        .filter((c) => c.key !== this.item?.key)
        .map((c) => c.key);
    },
    allCategories() {
      return this.allConfigs.filter((c) => c.type === "categories");
    },
    allObjects() {
      return this.allConfigs.filter((c) => c.type !== "categories");
    },
    rules() {
      const validateKey = (rule, value, callback) => {
        if (value && CONSTANTS.BLOCK_KEYS.includes(value.trim())) {
          callback(new Error("Mã trường trùng với mã hệ thống"));
        } else if (value && this.allFieldKeys.includes(value.trim())) {
          callback(new Error("Mã trường đã tồn tại"));
        } else {
          callback();
        }
      };
      return {
        order: [
          {
            required: true,
            message: "STT không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        type: [
          {
            required: true,
            message: "Tên không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        config: [
          {
            required: true,
            message: "Format không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        key: [
          {
            required: true,
            message: "Mã không được để trống",
            trigger: ["blur", "change"],
          },
          {
            pattern: PATTERNS.KEY,
            message: "Mã nhóm không hợp lệ",
            trigger: ["blur", "change"],
          },
          {
            validator: validateKey,
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "Tên không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    selectedType() {
      return this.typeOptions.find((o) => o.key === this.form.type);
    },
    disableOptions() {
      return [this.fieldType.RATIO, this.fieldType.CHECKBOX].includes(
        this.form.type
      );
    },
    showCategoryOptions() {
      return [
        this.fieldType.SELECT,
        this.fieldType.MULTIPLE_SELECT,
        this.fieldType.RATIO,
        this.fieldType.CHECKBOX,
      ].includes(this.form.type);
    },
    showConnectionOptions() {
      return [
        this.fieldType.CONNECTION,
        this.fieldType.MULTIPLE_CONNECTION,
      ].includes(this.form.type);
    },
    showDataType() {
      return [this.fieldType.TEXT].includes(this.form.type);
    },
    showDateFormat() {
      return [
        this.fieldType.DATE,
        this.fieldType.DATETIME,
      ].includes(this.form.type);
    },
    showMinMax() {
      return [this.fieldType.NUMBER].includes(this.form.type);
    },
    showColumn() {
      return this.form.show.column;
    },
    showFieldConfig() {
      return (
        this.selectedType &&
        ![
          this.fieldType.HTML,
          this.fieldType.MULTIPLE_SELECT,
          this.fieldType.FILE_IMAGES,
          this.fieldType.FILE_VIDEOS,
          this.fieldType.FILE_AUDIOS,
          this.fieldType.FILE_OTHERS,
          this.fieldType.LINK_3DS,
          this.fieldType.LINK_YOUTUBE,
        ].includes(this.form.type)
      );
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    loadFormData() {
      if (this.item) {
        this.form = JSON.parse(
          JSON.stringify({
            ...fieldInfoDefault,
            ...this.item,
          })
        );
      } else {
        this.form = JSON.parse(
          JSON.stringify({
            ...fieldInfoDefault,
            order: this.allFieldKeys.length,
          })
        );
      }
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let fields = [];
          if (this.item) {
            fields = this.object.extra?.fields.map((f) => {
              if (f.key === this.item.key) {
                return {
                  ...this.item,
                  ...this.form,
                };
              }
              return f;
            });
          } else {
            fields = [
              ...this.object.extra.fields,
              { ...fieldInfoDefault, ...this.form },
            ];
          }
          this.$emit("save", {
            payload: { fields },
            success: () => {
              notification(
                this,
                "success",
                this.isCreate ? "create" : "update",
                `trường dữ liệu`
              );
              this.$emit("close");
            },
            error: () => {
              notification(
                this,
                "error",
                this.isCreate ? "create" : "update",
                `trường dữ liệu`
              );
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
